import styled from 'styled-components'
import { Button, Form, Input } from 'antd'

export const Layout = styled.div`
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f5f5f5;
`
export const Container = styled.div`
	max-width: 32rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #e4e4e4;
	border-radius: 8px;
	padding: 44px;
	gap: 16px;
	box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
`
export const StyledForm = styled(Form)`
	width: 100%;
	margin-top: 0 !important;

	& .ant-form-item-label {
		padding-bottom: 4px;
		font-weight: 500;
	}
`
export const FormItem = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;
`
export const StyledLabel = styled.label`
	font-size: 14px;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.85);
	margin-bottom: 4px;
`
export const StyledInput = styled(Input)`
	width: 100%;
	max-width: 424px;
	height: 48px;
	padding: 8px 12px;
	border-radius: 6px;
	background-color: #fefefe;
`
export const StyledInputPassword = styled(Input.Password)`
	width: 100%;
	max-width: 424px;
	height: 48px;
	padding: 8px 12px;
	border-radius: 6px;
	background-color: #fefefe;
`
export const StyledButton = styled(Button)`
	width: 100%;
	max-width: 424px;
	height: 48px;
	border-radius: 6px;
	font-weight: 500;
`
export const LoaderContainer = styled.div`
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #ffffffa8;
`
